import { createContext } from 'react';

import * as graphql from 'generated/graphql';

interface IAuthorizationContext {
	authenticatedUser: graphql.User;
}

const AuthorizationContext = createContext<IAuthorizationContext | null>(null);

export default AuthorizationContext;
